export * from './portfolio';

export const SAVVY_SMALL_BLACK_LOGO_URL =
  'https://res.cloudinary.com/hbb0rvydd/image/upload/v1689113025/website-assets/small_black_logo.png';
